<template>
  <div>
    <Divider orientation="left">预览</Divider>
    <PointsNewDetail :form="form" :enterpriseAgentList="enterpriseAgentList"></PointsNewDetail>
    <div class="bom_btn">
      <div>
        <Button @click="next(null,-1)">上一步</Button>
        <Button type="primary" @click="next('form',1)" v-if="!$store.state.isPerson">下一步</Button>
        <Button type="primary" @click="submit('form',1)" v-else>提交</Button>

      </div>
    </div>
    <Modal v-model="modal" :closable="false" :mask-closable="false" width="460" footer-hide>

      <div class="">
        <Spin size="large" fix v-if="spinShow">
          <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
          <div>正在汇总材料文件进行电子签章，可能需要几分钟，请稍等...</div>
        </Spin>
        <div class="ivu-modal-confirm-head">
          <div class="ivu-modal-confirm-head-icon ivu-modal-confirm-head-icon-confirm">
            <Icon type="ios-help-circle" />
          </div>
          <div class="ivu-modal-confirm-head-title">提示</div>
        </div>
        <div class="ivu-modal-confirm-body">

          <p>请确认在“《上海市居住证》积分申请系统（<a target="_blank" href="https://jzzjf.rsj.sh.gov.cn/jzzjf">https://jzzjf.rsj.sh.gov.cn/jzzjf</a>）”内已提交申请</p>
        </div>
        <div class="ivu-modal-confirm-footer">
          <Button type="text" @click="modal = false; spinShow = false">取消</Button>
          <Button type="primary" @click="modelOk" :disabled="isRead">确认<span v-show="isRead">({{ second }}s)</span></Button>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
import PointsNewDetail from '../../pointsNewDetail/index.vue'
export default {
  props: {
    form: Object,
    enterpriseAgentList: Array,
  },
  components: {
    PointsNewDetail,
  },
  data() {
    return { modal: false, isRead: true, second: 3, spinShow: false }
  },
  methods: {
    //下一步

    next(name, val) {
      let _this = this
      //上一步
      if (name === null) {
        if (this.form.isPersonalInfoChanged) {
          this.$emit('next', this.$store.state.appInfoDataType['个人信息变更'])
        } else {
          this.$emit('next', this.$store.state.appInfoDataType['加分材料'])
        }
        return
      } else {
        _this.modal = true
        //定时器,倒计时
        let timer = setInterval(() => {
          if (_this.second > 0) {
            _this.second--
          } else {
            _this.isRead = false
            clearInterval(timer)
          }
        }, 1000)
      }
    },
    modelOk() {
      // this.$emit('next', this.$store.state.appInfoDataType['QrSub'])
      // this.modal = false
      this.spinShow = true
      window.location.href =
        this.$url + `/CA/RedirectToCASignByApplication?guid=${this.form.guid}&applicationCAType=1` //' 'https://jzzjf.rsj.sh.gov.cn/jzzjf'
    },
    async next(name, val) {
      let _this = this
      //上一步
      if (name === null) {
        if (this.form.isPersonalInfoChanged) {
          this.$emit('next', this.$store.state.appInfoDataType['个人信息变更'])
        } else {
          this.$emit('next', this.$store.state.appInfoDataType['加分材料'])
        }
        return
      } else {
        _this.modal = true
        //定时器,倒计时
        let timer = setInterval(() => {
          if (_this.second > 0) {
            _this.second--
          } else {
            _this.isRead = false
            clearInterval(timer)
          }
        }, 1000)
      }
    },
    async submit() {
      try {
        await this.$emit(
          'submit',
          '/api/services/app/JZZJFApi/SubmitApplicationByPerson',
          1,
          '提交成功'
        )
      } catch (error) {
        _this.$Message.error({
          content: '操作失败',
          background: true,
          duration: 6,
        })
      }
    },
  },
}
</script>
<style scoped>
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.demo-spin-col {
  height: 100px;
  position: relative;
  border: 1px solid #eee;
}
</style>